import ApiService from "./api.service";

class ProtocolService extends ApiService {
    getProtocolsData(sessionId) {
        return this.get(`api/meeting/protocol/getProtocolsData/${sessionId}`);
    }

    deleteProtocol(sessionId, id) {
        return this.delete(`api/meeting/protocol/deleteProtocol/${sessionId}/${id}`)
    }

    updateProtocolName(data, sessionId) {
        return this.post(`api/meeting/protocol/updateProtocolName/${sessionId}`, data)
    }

    downloadProtocol(sessionId, id) {
        return this.get(`api/meeting/protocol/downloadProtocol/${sessionId}/${id}`, { responseType: "arraybuffer" })
    }

    uploadProtocol(data) {
        return this.post(`api/meeting/protocol/uploadProtocol`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    }
}

export default new ProtocolService();
